import { injectable, inject } from 'inversify';
import { type DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import { validateDataroomTenant } from '@dataroom/tenant/validateDataroomTenant';
import { DataroomProcessingAdapter } from '@dealroadshow/file-uploader';
import { SocketClient, type ISocketClientFactory } from '@dataroom/socket-client';

@injectable()
class SocketProcessingAdapterFactory {
  constructor(
    @inject(SocketClient) private readonly socketClientFactory: ISocketClientFactory,
  ) {}

  create(tenantCode: DataroomTenant): DataroomProcessingAdapter {
    validateDataroomTenant(tenantCode);

    const socketClient = this.socketClientFactory(tenantCode);
    return new DataroomProcessingAdapter(socketClient);
  }
}

export default SocketProcessingAdapterFactory;
